import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
  useQuery,
} from '@tanstack/react-query';

import { API_HANDLERS } from 'api/apiHandlers';
import { FileUsageResponse } from 'api/types';

interface UseFileUsageQueryParams {
  fileId: string;
  enabled: boolean;
}

interface UseFileUsageQueryReturn {
  data: FileUsageResponse | undefined;
  isLoading: boolean;
  refetch: <TPageData>(
    options?: RefetchOptions & RefetchQueryFilters<TPageData>,
  ) => Promise<QueryObserverResult<FileUsageResponse, unknown>>;
}

export function useFileUsageQuery({
  fileId,
  enabled,
}: UseFileUsageQueryParams): UseFileUsageQueryReturn {
  const { data, isLoading, refetch } = useQuery(
    ['file-usage', fileId],
    () => API_HANDLERS.FILES.GET_USAGE(fileId).then((res) => res.data),
    { enabled },
  );

  return { data, isLoading, refetch };
}
